import { pick } from 'lodash/fp';
import { type MobilityModuleSpecsFragment } from '../../../../api/fragments/MobilityModuleSpecs';
import { type UploadFileWithPreviewFormDataFragment } from '../../../../api/fragments/UploadFileWithPreviewFormData';
import { type MobilityEmailContentInput } from '../../../../api/types';

export enum HeaderTabs {
    MainDetails = 'mainDetails',
    EmailContent = 'email',
}

export type MobilityEmailContentFormProps = {
    module: MobilityModuleSpecsFragment;
};

export type MobilityEmailContentInputForm = MobilityEmailContentInput & {
    introImage?: File | UploadFileWithPreviewFormDataFragment;
};

export type MobilityCustomerEmailContentInput = {
    bookingConfirmation: MobilityEmailContentInputForm;
    bookingCancellation: MobilityEmailContentInputForm;
    bookingAmendment: MobilityEmailContentInputForm;

    bookingCheckedIn: MobilityEmailContentInputForm;
    bookingComplete: MobilityEmailContentInputForm;
    bookingReminder: MobilityEmailContentInputForm;
};

export type MobilityOperatorEmailContentInput = {
    bookingConfirmation: MobilityEmailContentInputForm;
    bookingCancellation: MobilityEmailContentInputForm;
    bookingAmendment: MobilityEmailContentInputForm;
};

export type MobilityEmailContentFormikValue = {
    emailContents: {
        id: string;
        locationId?: string;
        isHomeDelivery: boolean;
        customers: MobilityCustomerEmailContentInput;
        operators: MobilityOperatorEmailContentInput;
    }[];
};

export default HeaderTabs;

const extractEmailContent = (email: MobilityEmailContentInputForm) => ({
    ...pick(['contentText', 'introTitle', 'subject', 'isEmailEnabled'], email),
});

export const getMobilityEmailContentFromForm = (values: MobilityEmailContentFormikValue) =>
    values.emailContents.map(emailContent => ({
        ...emailContent,
        customers: {
            bookingAmendment: extractEmailContent(emailContent.customers.bookingAmendment),
            bookingCancellation: extractEmailContent(emailContent.customers.bookingCancellation),
            bookingCheckedIn: extractEmailContent(emailContent.customers.bookingCheckedIn),
            bookingComplete: extractEmailContent(emailContent.customers.bookingComplete),
            bookingConfirmation: extractEmailContent(emailContent.customers.bookingConfirmation),
            bookingReminder: extractEmailContent(emailContent.customers.bookingReminder),
        },

        operators: {
            bookingAmendment: extractEmailContent(emailContent.operators.bookingAmendment),
            bookingCancellation: extractEmailContent(emailContent.operators.bookingCancellation),
            bookingConfirmation: extractEmailContent(emailContent.operators.bookingConfirmation),
        },
    }));
